




import { Component, Vue, Prop } from "vue-property-decorator";
import { isTaskUnsuccessful, isTaskComplete, isTaskCancelled, isTaskPending, RequestTaskModel, RequestStatus } from "@/api/Requests";
import { requestIcon } from "@/assets/icons/RequestIcons";

@Component
class RequestTaskStatusIcon extends Vue {
  @Prop() readonly task?: RequestTaskModel;

  isTaskComplete = isTaskComplete;
  isTaskUnsuccessful = isTaskUnsuccessful;
  isTaskPending = isTaskPending;
  isTaskCancelled = isTaskCancelled;

  icon() {
    if (!this.task) return "";

    return requestIcon(this.status);
  }

  get status() {
    let status = RequestStatus.InProgress;
    if (!this.task) return status;

    if (isTaskPending(this.task)) {
      status = RequestStatus.Pending;
    } else if (isTaskUnsuccessful(this.task)) {
      status = RequestStatus.CompleteWithErrors;
    } else if (isTaskComplete(this.task)) {
      status = RequestStatus.Complete;
    } else if (isTaskCancelled(this.task)) {
      status = RequestStatus.Cancelled;
    }
    return status;
  }

  get tooltipMessage() {
    switch (this.status) {
      case RequestStatus.InProgress:
        return "Task is in progress";
      case RequestStatus.Complete:
        return "Task completed successfully";
      case RequestStatus.CompleteWithErrors:
        return "Task was completed, but unsuccessfully";
      case RequestStatus.Cancelled:
        return "Task was cancelled";
    }
    return "";
  }
}

export default RequestTaskStatusIcon;
